import { isEmpty } from "lodash";
import I18n from "pages/_components/I18n";
import Loader from "pages/_components/Loader";
import { string } from "prop-types";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actions as echeckActions } from "reducers/echecks";

const AmountEchecks = ({ selectedAccountId }) => {
    const { echeckAmountData, fetching } = useSelector((state) => state.echecks);
    const dispatch = useDispatch();

    useEffect(() => {
        if (selectedAccountId) {
            dispatch(echeckActions.requestAmountEchecks(selectedAccountId));
        }
    }, [selectedAccountId]);

    useEffect(
        () => () => {
            dispatch(echeckActions.cleanAmountEchechs({}));
        },
        [],
    );

    if (fetching) {
        return <Loader />;
    }
    return (
        <>
            {!isEmpty(echeckAmountData) && (
                <div className="flex columns-2 w-full justify-between">
                    <div className="echeck">
                        <p className="primary">
                            <I18n id="echeqs.daily.limit" />:
                            <span className="bold"> {` ${echeckAmountData.maxLimit}`}</span>
                        </p>
                        <p className="primary">
                            <I18n id="echecks.available.amount" />:
                            <span className="bold">{` ${echeckAmountData.maxLimitProduct}`}</span>
                        </p>
                    </div>
                    <div className="echeck content-end">
                        <p className="primary">
                            <I18n id="echecks.available" />:
                            <span className="bold">{` ${echeckAmountData.maxEcheqAmount -
                                echeckAmountData.usedEcheqAmount}`}</span>
                        </p>
                    </div>
                </div>
            )}
        </>
    );
};

AmountEchecks.propTypes = {
    selectedAccountId: string.isRequired,
};

export default AmountEchecks;
